import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../store/use-theme";
import clsx from "clsx";

type ThemeToggleProps = {
  className?: string;
  compact?: boolean;
};

export default function ThemeToggle({
  className,
  compact = false,
}: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      className={clsx(
        "group relative inline-flex items-center justify-center rounded-xl border border-edge bg-surface-elevated text-light-gray transition-all duration-200 hover:border-edge-strong hover:text-heading-color hover:shadow-glow-sm",
        compact ? "h-9 w-9" : "h-10 w-10",
        className,
      )}
    >
      <FontAwesomeIcon
        icon={faSun}
        className={clsx(
          "absolute text-sm transition-all duration-300",
          isDark
            ? "rotate-90 scale-0 opacity-0"
            : "rotate-0 scale-100 opacity-100 text-amber-500",
        )}
      />
      <FontAwesomeIcon
        icon={faMoon}
        className={clsx(
          "absolute text-sm transition-all duration-300",
          isDark
            ? "rotate-0 scale-100 opacity-100 text-indigo-300"
            : "-rotate-90 scale-0 opacity-0",
        )}
      />
    </button>
  );
}
